import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class CreateNewpartnerIdService {

  constructor(private http: HttpClient) { }

  async createNew(data) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin': '*'
        })
      };
      let response = await this.http
        .post(`${appApiResources.createNewPartnerIDNew}`, data, httpOptions)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  updatePartnerDetails(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*'
      })
    };
    return this.http
      .post(`${appApiResources.updatePartnerId}`, data, httpOptions)
  }

}
